<template>
    <VContainer fluid>
        <VRow>
            <VCol
                class="pa-10 d-none d-md-inline"
                data-cy="sidebar-left"
                cols="3"
            >
                <content-doc path="sidebar/left" :head="false" />
            </VCol>
            <VCol class="pa-10">
                <checkout>
                    <template #checkoutClosed>
                        <div v-if="true" data-cy="force-close">
                            <content-doc path="closed" :head="false" />
                        </div>
                        <checkout />
                    </template>
                </checkout>
            </VCol>
            <VCol
                class="pa-10 d-none d-md-inline"
                data-cy="sidebar-right"
                cols="3"
            >
                <content-doc path="sidebar/right" :head="false" />
            </VCol>
        </VRow>
    </VContainer>
</template>

<script setup async lang="ts">
    const config = useGlobyConfig();
    const nuxtConfig = useRuntimeConfig();

    useServerSeoMeta({
        title: `${config.organization.slogan} | Globy`,
        ogTitle: `${config.organization.slogan} | Globy`,
        ogUrl: nuxtConfig.public.base_url,
        description: config.organization.description,
        ogDescription: config.organization.description,
    });
</script>
